export default __webpack_public_path__ + "static/media/samsung.603552d4.PNG";